import React from 'react';
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from '@react-google-maps/api';

type Props = {
    lat: number;
    lng: number;
    label: string;
};

const containerStyle = {
    width: '100%',
    height: '18.75rem',
};

export const Map: React.FC<Props> = ( { lat, lng, label } ) => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyBhngeqpbUIOlwNQYlRrllEl94NAzAxgvg',
    } );

    const center = { lat, lng };

    if ( ! isLoaded ) {
        return <p>Loading map…</p>;
    }

    return (
        <GoogleMap mapContainerStyle={ containerStyle } center={ center } zoom={ 15 }>
            <Marker position={ center }>
                <InfoWindow position={ center }>
                    <div>{ label }</div>
                </InfoWindow>
            </Marker>
        </GoogleMap>
    );
};